import React from "react";
import { useTranslation } from "gatsby-plugin-react-i18next";
import SearchIcon from "@mui/icons-material/Search";

import { Search, SearchIconWrapper, StyledInputBase } from "./styles";

export default function Searchbar({
  onSearch = () => {},
  searchTerm = "",
  onInputChange = () => {},
}) {
  const { t } = useTranslation();

  return (
    <Search onSubmit={onSearch}>
      <form>
        <SearchIconWrapper>
          <SearchIcon fontSize="medium" />
        </SearchIconWrapper>
        <StyledInputBase
          placeholder={t("searchbar.search_placeholder")}
          inputProps={{ "aria-label": "search" }}
          value={searchTerm}
          onChange={onInputChange}
        />
      </form>
    </Search>
  );
}
